import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isInClub
    ? _c(
        VListItem,
        {
          on: {
            click: function ($event) {
              return _setup.emit("click")
            },
          },
        },
        [
          _c(
            VListItemIcon,
            { staticClass: "my-auto" },
            [
              _c(VImg, {
                attrs: {
                  src: "/static/_v1/pd/icons/ui-kit/club/club-check.svg",
                  width: "24",
                  height: "24",
                  alt: _setup.translate("Иконка Галочка Клуба"),
                  eager: "",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VListItemContent,
            { staticClass: "py-2" },
            [
              _c(
                VListItemTitle,
                { staticClass: "text-body-1 text--text" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_setup.translate("Клубная карта")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                VListItemSubtitle,
                { staticClass: "text-body-2 text-info--text" },
                [
                  _vm._v(
                    "\n      " + _vm._s(_setup.cardDateEndLabel) + "\n    "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }